import App              from './App/App';
import Router           from './App/Router';
import base64_decode    from './scripts/base64';

const app = new App();
window.APP = app;

const router = new Router(
    base64_decode(window.routes)
);
window.Router = router;